import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
import utils from "@/common/utils";
import {dateMonth, getMonthStartDate} from "@/common/dateTime";

const vPrototype = new Map<string, any>();

vPrototype.set("exportReport", (pdfDom: HTMLFormElement, name: string, callback: any) => {
    const a = document.querySelector('#pdfDom') as any;
    const b = document.querySelector('#pdfDom2') as any;
    const aa = a.cloneNode(true);
    (document.querySelector("#pdfDomAll") as any).innerHTML = "";
    (document.querySelector("#pdfDomAll") as any).appendChild(aa);
    const bb = b.cloneNode(true);
    (document.querySelector("#pdfDomAll") as any).appendChild(bb);
    const w = pdfDom.offsetWidth;
    const h = pdfDom.offsetHeight;
    html2Canvas(pdfDom, {
        allowTaint: true,
        useCORS: true,
        scale: 1,
        width: w,
        height: h,
    }).then((canvas) => {
            const pdf = new JsPDF('p', 'mm', 'a4'); //A4纸，纵向
            const ctx = canvas.getContext('2d') as any;
            const a4w = 190;
            const a4h = 277 //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
            const imgHeight = Math.floor(a4h * canvas.width / a4w);
            let renderedHeight = 0;
            while (renderedHeight < canvas.height) {
                const page = document.createElement("canvas") as any;
                page.width = canvas.width;
                page.height = Math.min(imgHeight, canvas.height - renderedHeight); //可能内容不足一页
                //用getImageData剪裁指定区域，并画到前面创建的canvas对象中
                page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas
                    .height - renderedHeight)), 0, 0);
                pdf.addImage(page.toDataURL('image/PNG', 1.0), 'PNG', 10, 10, a4w, Math.min(a4h, a4w * page.height / page.width)); //添加图像到页面，保留10mm边距
                renderedHeight += imgHeight;
                if (renderedHeight < canvas.height)
                    pdf.addPage(); //如果后面还有内容，添加一个空页
            }
            const file = utils.base64ConvertFile(pdf.output("dataurlstring"), name);
            const formData = new FormData();
            formData.append('file', file);
            formData.append('category', 'public')
            pdf.save(name + '.pdf');
            callback();
        }
    )
});

vPrototype.set("timeContrast", (termValidity: string) => {
    if (termValidity) {
        const currentTime = getMonthStartDate();
        // 到期月份
        if(dateMonth(termValidity, currentTime, 6)){
            return "myDadge-green";
        }else if(dateMonth(termValidity, currentTime, 3)){
            return 'myDadge-orange';
        }else if(dateMonth(termValidity, currentTime, 0)){
            return 'myDadge-yellow';
        }else{
            return 'myDadge-red';
        }
    } else {
        return 'myDadge-red';
    }
});

export default vPrototype
